import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { queryKeys } from "#shared/queryKeys/queryKeys";

import { fetchQuoteRequestLineOverthickness } from "./fetchQuoteRequestLineOverthickness.api";

export const quoteRequestLineOverthicknessQuery = (id: string | undefined) => ({
  queryKey: queryKeys.quoteRequestLines.overthickness(id),
  queryFn: () => fetchQuoteRequestLineOverthickness(id!),
  staleTime: STALE_TIME,
  enabled: !!id,
});
